import { QUERY_KEYS } from 'api/query-keys';
import { availabilityService } from 'api/services';
import { UpdateWorkersAvailabilityDto } from 'api/services/availability/availability-service.dto';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { useAlert } from 'shared/components/alerts/use-alert';

export const useUpdateWorkerAvailability = (
  workerId: string,
  fromDate: DateTime,
  searchTerm: string | undefined,
  cancel: () => void
) => {
  const mutationFn = async (workerAvailability: Omit<UpdateWorkersAvailabilityDto, 'workerId'>) =>
    await availabilityService.updateWorkerAvailability({ workerId, ...workerAvailability }, 'ogp');
  const queryClient = useQueryClient();
  const { t } = useTranslation('all-platforms-common');
  const { alertSuccess, alertError } = useAlert();

  const { mutate: updateWorkerAvailability } = useMutation(mutationFn, {
    onSuccess: () => {
      queryClient.invalidateQueries(
        QUERY_KEYS.workersAvailability(searchTerm, fromDate.toISODate(), [])
      );
      alertSuccess(t('edit_availability.update_success', { ns: 'all-platforms-common' }));
      cancel();
    },
    onError: (e) => {
      alertError(e);
    },
  });

  return {
    updateWorkerAvailability,
  };
};
